import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { graphql } from 'react-apollo';
import * as compose from 'lodash.flowright';
import { gql } from 'apollo-boost';

import NoData from "../../no-data/no-data.component";

//styles
import { Container, Row, Col, Modal, ListGroup , Tabs ,Tab } from 'react-bootstrap';
import { Button, Fab, Chip , Tooltip} from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBoxOpen, faUserFriends } from '@fortawesome/free-solid-svg-icons';
import PowerSettingsNewOutlinedIcon from '@material-ui/icons/PowerSettingsNewOutlined';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import DeleteIcon from '@material-ui/icons/Delete';
// import img from '../../../images/member.png';
// import DateRangeIcon from '@material-ui/icons/DateRange';
import Loader from 'react-loader-spinner';

// this component represents job card in jobs paage
class JobCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            type: props.type ? props.type : ''
        }
        this.handleCloseJob = this.handleCloseJob.bind(this);
    }
    handleCloseJob = (id) => {
        this.props.closeJob({
            variables: {
                job_id: id,
                job_status_id: 2
            }
        }).then((res, loading) => {
            if (res.data.jobEdit.Status.code === 200) {
                this.props.callBack("update");
            }
        }).catch((err) => {
            console.log(err)
        });
    }
    handleDeleteJob = (id) => {
        this.props.deleteJob({
            variables: {
                job_id: id
            }
        }).then((res) => {
            this.loading = true;
            if (res.data.jobDelete.Status.code === 200) {
                this.loading = false;
                this.props.callBack("update");
            }
        }).catch((err) => {
            console.log(err)
        });
    }
    handlePublish = (id) => {
        this.props.publishJob({
            variables: {
                job_id: id,
                is_Draft: false
            }
        }).then((res, loading) => {
            if (res.data.jobEdit.Status.code === 200) {
                this.props.callBack("update");
            }
        }).catch((err) => {
            console.log(err)
        });
    }
    buttonGroup = (job) => {
        if (this.state.type === 'liveJobs') {
            return (
                <Col md={3} sm={12} className="text-right  order-md-2 order-1">
                    <Tooltip title="Close">
                        <Fab
                            onClick={() => this.handleCloseJob(job.id)}
                            size="small" className="bg-transparent mr-1"
                        ><PowerSettingsNewOutlinedIcon style={{ fontSize: '1.4rem' }} /></Fab>
                    </Tooltip>
                    <Tooltip title="Edit">
                        <Fab
                            size="small"
                            className="bg-transparent mr-1"
                            onClick={() => {
                                window.scrollTo({ top: 0, behavior: 'smooth' });
                                this.props.history.push({
                                    pathname: '/createJob',
                                    state: job
                                })
                            }}
                        >
                            <EditOutlinedIcon style={{ fontStyle: '1rem' }} />
                        </Fab>
                    </Tooltip>
                    <Tooltip title="Delete">
                        <Fab
                            onClick={() => this.handleDeleteJob(job.id)}
                            size="small" className="bg-transparent mr-1"
                        >
                            <DeleteIcon style={{ fontStyle: '1rem' }} />
                        </Fab>
                    </Tooltip>
                </Col>
            )
        }
        else if (this.state.type === 'closedJobs') {
            return null
        }
        else if (this.state.type === 'draftJobs') {
            return (
                <Col md={4} xs={12} className="text-right ">
                    <Tooltip title="Publish">
                        <Fab onClick={() => this.handlePublish(job.id)}
                            size="small"
                            className="bg-transparent mr-1"
                        >
                            <CheckCircleOutlineIcon style={{ fontSize: '1.4rem' }} />
                        </Fab>
                    </Tooltip>
                    <Tooltip title="Edit">
                        <Fab
                            size="small"
                            className="bg-transparent mr-1"
                            onClick={() => {
                                window.scrollTo({ top: 0, behavior: 'smooth' });
                                this.props.history.push({
                                    pathname: '/createJob',
                                    state: job
                                })
                            }}
                        ><EditOutlinedIcon style={{ fontStyle: '1rem' }} />
                        </Fab>
                    </Tooltip>
                    <Tooltip title="Delete">
                        <Fab
                            onClick={() => this.handleDeleteJob(job.id)}
                            size="small" className="bg-transparent mr-1"
                        >
                            <DeleteIcon style={{ fontStyle: '1rem' }} />
                        </Fab>
                    </Tooltip>
                </Col>
            )
        }
    }
    loading = false;
    render() {
        if (!this.props.data) {
            return (
                <div>
                    Loading...
                </div>
            )
        }
        else if (this.props.data.length === 0) {
            return (<NoData />)
        }
        else {
            return (
                <Container className="pt-3 pb-3">
                    {this.props.data?.map(job =>
                        <div key={job.id}>
                            <Row className="align-items-top">
                                <Col md={9} xs={12} className="w-100 text-left order-md-1 order-2">
                                    <button 
                                        className="bg-transparent border-0 text-left" 
                                        onClick={e=>{
                                            let btnGroup = document.querySelector('.btn-group');
                                            let id = job.id;
                                            window.scrollTo({ top: 0, behavior: 'smooth' });
                                            this.props.history.push({
                                                pathname: `/jobDetails/${id}` , 
                                                state: btnGroup
                                                 })
                                            }}
                                    >
                                        <h5 className="captialize">{job.title ? job.title : ''}</h5>
                                        <p className="text-orange d-inline-block pr-1 m-0">{job.company ? job.company.name : ''}</p>
                                        <p className="text-grey d-inline-block pl-2 m-0">{job.created_at ? job.created_at : ''}</p>
                                        <p>{job.brif && 
                                            <div>{ job.brif.length > 192 ? 
                                                    <div>{ job.brif.substring(0,191) }<button className="bg-transparent border-0 text-orange underline m-0">See More</button></div>
                                                    : job.brif }
                                            </div>}
                                        </p>
                                    </button>
                                </Col>
                                {this.buttonGroup(job)}
                            </Row>
                            <button 
                                className="bg-transparent border-0 w-100" 
                                onClick={e => {
                                    let id = job.id;
                                    window.scrollTo({ top: 0, behavior: 'smooth' });
                                    this.props.history.push({
                                        pathname: `/jobDetails/${id}`,
                                        state: "<div></div>"
                                         })
                                    }}
                            >
                                <Row className="pt-1 ">
                                    <Col xs={4} className="text-left text-center-sm">
                                        <FontAwesomeIcon icon={faUserFriends} size="lg" className="text-grey" />
                                        <span className="pl-1">{job.ApplicationsGet.data && job.ApplicationsGet.data.length + ' Applicant'}</span>
                                    </Col>
                                    <Col xs={4} className="text-left text-center-sm">
                                        <FontAwesomeIcon icon={faBoxOpen} size="lg" className="text-grey" />
                                        <span className="pl-1">{job.questions && job.questions.length + ' Question'}</span>
                                    </Col>
                                    <Col xs={12} className="text-left"><p className="mb-0 mt-2">Tags</p>
                                    {job.tags?.map(tag =>
                                            <Button key={tag.name} size="small" className="mr-1 pr-1 pl-1" variant="outlined" disabled>
                                                {tag.name}
                                            </Button>
                                    )}
                                    </Col>
                                </Row>
                            </button>
                            <hr />
                        </div>
                    )}
                    {this.loading &&
                        <div  className="loading">
                            <Loader
                                type="TailSpin"
                                color="white"
                                height={50}
                                width={50}
                            />
                    </div>
                    }                
                </Container>
            );
        }
    }
}
const CLOSE_JOB = gql`
mutation($job_id : Int $job_status_id : Int ){
    jobEdit(Inputs:{
      job : { id : $job_id }
      job_status_id : $job_status_id
    }){
      Status {
        code
        message
      }
    }
  }
 `
const DELETE_JOB = gql`
 mutation($job_id : Int){
    jobDelete(Inputs:{
      id : $job_id
    }){
      Status{
        code 
      }
    }
  }`
const PUBLISH_JOB = gql`
  mutation($job_id : Int  , $is_Draft : Boolean){
    jobEdit(Inputs:{
      job : { id : $job_id }
      is_Draft : $is_Draft
    }){
      Status {
        code
        message
      }
    }
  }
  
   `
export default compose(
    graphql(CLOSE_JOB, {
        name: "closeJob"
    }),
    graphql(DELETE_JOB, {
        name: "deleteJob"
    }),
    graphql(PUBLISH_JOB, {
        name: "publishJob"
    })
)(withRouter(JobCard));